import { openDB } from 'idb';

const DB_NAME = 'piperz-provider-db';
const STORE_AUTH = 'auth';
const STORE_SESSIONS = 'sessions';

export async function getDB() {
    return openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_AUTH)) {
                db.createObjectStore(STORE_AUTH);
            }
            if (!db.objectStoreNames.contains(STORE_SESSIONS)) {
                db.createObjectStore(STORE_SESSIONS);
            }
        },
    });
}

// 🔐 Usuário
export async function saveUser(user: any) {
    const db = await getDB();
    await db.put(STORE_AUTH, user, 'user');
}

export async function getUser() {
    const db = await getDB();
    return await db.get(STORE_AUTH, 'user');
}

export async function deleteUser() {
    const db = await getDB();
    await db.delete(STORE_AUTH, 'user');
}

// 📅 Sessões
export async function saveSessions(sessions: any[]) {
    const db = await getDB();
    await db.put(STORE_SESSIONS, sessions, 'today_sessions');
}

export async function getSessions() {
    const db = await getDB();
    return await db.get(STORE_SESSIONS, 'today_sessions');
}

export async function deleteSessions() {
    const db = await getDB();
    await db.delete(STORE_SESSIONS, 'today_sessions');
}

export async function saveSession(id: string, session: any) {
    const db = await getDB();
    await db.put(STORE_SESSIONS, session, id);
}

export async function getSession(id: string) {
    const db = await getDB();
    return await db.get(STORE_SESSIONS, id);
}

export async function deleteSession(id: string) {
    const db = await getDB();
    await db.delete(STORE_SESSIONS, id);
}